  <template>
  <div>
    <div class="flex infline-flex  h-200 w-200">
      <img
        class="mt-10"
        style="display: block;
            margin-left: auto;
            margin-right: auto;
            width:200px;
            height:200px;"
        alt="Vue logo"
        src="@/assets/logo-fomapo.png"
      />
    </div>
    <div>
      <h1 class="text-4xl text-center m-4 font-semibold">
        Fondo Magisterial Potosino
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
